import { Facets } from "@/components/Search/SearchResults/StateComponents/Facets/facets.container";
import {
    MobileFacets,
    MobileFacetsProps
} from "@/components/Search/SearchResults/StateComponents/Facets/MobileFacets/mobileFacets.container";

const ProductFacets = () => <Facets component={"PRODUCT_FACETS"} />;
const MobileProductFacets = (props: MobileFacetsProps) => (
    <MobileFacets
        {...props}
        FacetsComponent={ProductFacets}
    />
);

export { MobileProductFacets, ProductFacets };
